<template>
  <v-chip
    x-small
    :style="estiloStatus()"        
    outlined
    >{{ label }}</v-chip
  >
</template>

<script>
export default {
  props: {
    label: String,
    cores: Array,
  },
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
    estiloStatus() {
      return {
        color: `rgb(${this.cores[0]},${this.cores[1]},${this.cores[2]})`,
        "background-color": "white !important",
        "border-color": `rgb(${this.cores[0]},${this.cores[1]},${this.cores[2]}) !important`,
      };
    },
  },
};
</script>

<style>
</style>